import styled from 'styled-components';

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 2px;
  background-color: transparent;
  border: 1.5px solid #000;
  cursor: pointer;

  font-family: 'Lato';
  font-style: normal;
  font-weight: 900;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.5px;
  text-align: center;
  color: #000;
  transition: ease 0.2s;

  :active {
    background-color: #333;
    border: 1.5px solid #333;
    color: #fff;
  }

  @media (hover: hover) {
    :hover {
      background-color: #333;
      border: 1.5px solid #333;
      color: #fff;
    }
  }

  &.disabled {
    background-color: #757575;
    border: 1.5px solid #757575;
    color: #fff;
  }
`;
